"use strict";
exports.__esModule = true;
var Dispatcher = /** @class */ (function () {
    function Dispatcher() {
        this.listeners = [];
    }
    Dispatcher.prototype.addListener = function (fn) {
        this.listeners.push(fn);
    };
    Dispatcher.prototype.removeListener = function (fn) {
        this.listeners = this.listeners.filter(function (cur) { return cur !== fn; });
    };
    Dispatcher.prototype.dispatch = function (action) {
        this.listeners.forEach(function (currentListener) {
            currentListener(action);
        });
    };
    return Dispatcher;
}());
exports["default"] = Dispatcher;
